import {Component, Attribute} from "@angular/core";

@Component({
  selector: "core-attribute-child",
  template: `
 <p>{{ text }}</p>
    `,
})
class AttributeChildComponent {
  constructor( @Attribute("text") private text: string) {
  }
}

@Component({
  selector: "core-attribute",
  template: `
  <usecase-container title="Arrtibute" src="core/attribute">
    <usecase-content>
      <core-attribute-child text="Angular 2"></core-attribute-child>
    </usecase-content>
  </usecase-container>
  `,
  directives: [AttributeChildComponent]
})
export class AttributeComponent {
}



/** WEBPACK FOOTER **
 ** ./script/core/attribute/component.ts
 **/